import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";

const reviews = [
    {
        name: "Amit Patyane",
        text: "Good learning experience. Best teacher Mr. Narendra Sir. Supportive staff. Reliable classes. Good for job person as like me."
    },
    {
        name: "Rupesh Kadam",
        text: "The best and very interactive way of teaching. Very smooth classes and very friendly."
    },
    {
        name: "Ashwini Aher",
        text: "It was a good learning experience."
    },
    {
        name: "Dhanshree Joshi",
        text: "Mentor was very humble and kind. But how course completion was delayed to complete by month from the committed date."
    }
];

const GoogleReviews = () => {
    return (
        <section className="reviews-section py-2 mb-5 mt-3">
            <Container>
                <h2 className="fw-bold text-center ">
                    Google Reviews </h2>
                <div className="edu-underline mx-auto mb-5"></div>

                {/* <h4 className="text-center fw-bold mb-4">
                     <span className="text-primary">Reviews</span>
                </h4> */}

                <Row className="g-4">
                    {reviews.map((review, index) => (
                        <Col md={6} lg={3} key={index}>
                            <Card className="review-card h-100 text-center">
                                <Card.Body>
                                    <FaUserCircle className="user-icon mb-3" />
                                    <h6 className="review-name">{review.name}</h6>
                                    <p className="review-text">{review.text}</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
{/* 
                <div className="text-center mt-4">
                    <Button className="btn-grad border-0" size="sm">
                        Book Demo
                    </Button>
                </div> */}
            </Container>
        </section>
    );
};

export default GoogleReviews;
